// frontend/src/utils/avatar.js
// Uploaded avatars are served from the backend origin, same as part/ticket
// attachments (see PartForm.js's attachment links) -- REACT_APP_SOCKET_URL
// is blank in production (same origin via Nginx) and set in dev.
export const avatarUrl = (avatarPath) =>
    avatarPath ? `${process.env.REACT_APP_SOCKET_URL || ''}${avatarPath}` : undefined;
